























































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { Menu, MenuItem, Submenu } from "element-ui";
import {
    faExchangeAlt,
    faHandHoldingUsd,
    faShare,
    faSignOutAlt,
} from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import { Action } from "vuex-class";

Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Submenu);

library.add(faExchangeAlt);
library.add(faShare);
library.add(faHandHoldingUsd);
library.add(faSignOutAlt);

@Component({
    name: "app-sidebar",
})
export default class AppSidebar extends Vue {
    @Action("auth/logout") logout!: () => void;
}
